import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

$(document).on('click', ".gfwol.is-clickable", function (e) {
    e.preventDefault();

	$(".lot-gallery-fullwidth-container").html("");
	
	$(".lot-gallery-fullwidth-container").append('<div class="lot-gallery-fullwidth"><div class="lot-gallery-fullwidth-carousel"></div></div><div class="galleryFullwidthClose"><div class="gfwc"></div></div>');
	
	$(".lot-gallery-fullwidth-carousel").append($(".lot-gallery-fw").html());
	
	var currentSlide = $(".lot-details__gallery-carousel .slick-current").data("slick-index");
	
	$(".lot-gallery-fullwidth-carousel").slick({
		arrows: true,
		fade: true,
		prevArrow: '<button type="button" data-role="none" class="slick-prev slick-nav-button" aria-label="Previous" tabindex="0" role="button"><div class="gfwal"></div></button>',
		nextArrow: '<button type="button" data-role="none" class="slick-next slick-nav-button" aria-label="Next" tabindex="0" role="button"><div class="gfwar"></div></button>',
        initialSlide: currentSlide
	});
});

$(document).on('click', ".galleryFullwidthClose", function() {	
	$(".lot-gallery-fullwidth-container").html("");	
});



// WEBPACK FOOTER //
// ./app/components/lot-details/js/lot-gallery-fullwidth.component.js